import { createMetaManager } from 'vue-meta';

export const META_MANAGER = createMetaManager();